export default __webpack_public_path__ + "static/media/emergency-preparedness-and-response-plan.c47a92f2.pdf";